export class FsgmConfig {
    organizationId: string;
    siteUnitId: string;
    businessUnitId: string;
    stack: string;
}
